/**
 * BriefText — renders the SAGE morning brief (terminal-style structured text)
 * with semantic coloring instead of a raw dump. Line markers from the synthesis
 * engine: `!` warning, `X` blocked, `$` money, `>` delegatable, `[HIGH]`
 * priority, ALL-CAPS section headers, `──` dividers.
 */
export default function BriefText({ text }: { text: string }) {
  const lines = text.replace(/\r/g, "").split("\n");
  return (
    <div className="font-mono text-body-sm leading-relaxed whitespace-pre-wrap break-words">
      {lines.map((line, i) => {
        const trimmed = line.trim();
        if (/^─+$/.test(trimmed)) return <div key={i} className="border-t my-2" />;
        let cls = "text-text";
        if (/^[A-Z][A-Z ()0-9]+$/.test(trimmed) && trimmed.length > 3) cls = "text-accent font-semibold";
        else if (trimmed.startsWith("!")) cls = "text-warning";
        else if (trimmed.startsWith("X ")) cls = "text-danger";
        else if (trimmed.startsWith("[HIGH]")) cls = "text-danger";
        else if (trimmed.startsWith("$")) cls = "text-biome-finance";
        else if (trimmed.startsWith(">")) cls = "text-text-muted";
        else if (trimmed.startsWith("sources:") || trimmed.startsWith("generated") || trimmed.startsWith("[Cached")) cls = "text-text-dim text-caption";
        return <div key={i} className={cls}>{line || " "}</div>;
      })}
    </div>
  );
}
